module.exports = __webpack_public_path__ + "img/banner_null.ae2951c9.png";